module.exports = __webpack_public_path__ + "ab8459976d2f78ba1c291edccf745b00.png";